module.exports = __webpack_public_path__ + "img/monitor.578bc240.png";